import { fetchJsonByDelete, fetchJsonByGet, fetchJsonByPut, noResponseDelete } from './execute';
import { fromGroup, fromGroupFix, fromUser, fromUserFix } from '../converters/permissionsConverter';
import { getParams } from '../reducers/analyticsApp';

export const fetchPermissions = () => (dispatch, getState) =>
  fetchJsonByGet('/authorization/me/permissions/static', getParams(getState())).then(
    (response) => ({ permissions: response })
  );

export const fetchGroups = () => (dispatch, getState) =>
  fetchJsonByGet('/authorization/groups', getParams(getState())).then((response) => ({
    groups: response.map(fromGroup),
  }));

export const saveGroup = (group) => (dispatch, getState) =>
  fetchJsonByPut('/authorization/groups', group, getParams(getState())).then((response) => ({
    group: fromGroupFix(response),
  }));

export const deleteGroup = (groupId) => (dispatch, getState) =>
  fetchJsonByDelete(`/authorization/groups/${groupId}`, getParams(getState())).then((response) => ({
    groupId: response.name,
  }));

export const fetchUsers = () => (dispatch, getState) =>
  fetchJsonByGet('/authorization/users', getParams(getState())).then((response) => ({
    users: response.map(fromUser),
  }));

export const saveUser = (user) => (dispatch, getState) =>
  fetchJsonByPut('/authorization/users', user, getParams(getState())).then((response) => ({
    user: fromUserFix(response),
  }));

export const deleteUser = (userId) => (dispatch, getState) =>
  noResponseDelete(`/authorization/users/${userId}`, getParams(getState())).then(() => ({
    userId,
  }));
